import * as mutationTypes from './mutation-types'
import api from '@/store/api/customer/mfa'

const initialState = () => ({
    mfaList: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        mfaList: state => state.mfaList.data,
        pagination: state => state.mfaList.pagination
    },
    actions: {
        /**
         * @param {{params: {}}} data
         * @returns {Promise<*>}
         */
        listMfa: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listMfa(data)
                const mfaList = {
                    ...response,
                    pagination: response.pagination
                }

                commit(mutationTypes.SET_MFA_LIST, mfaList)
                return mfaList
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{customer_id: number, account_name: string, secret_key: string}} data
         * @returns {Promise<*>}
         */
        createMfa: async ({dispatch}, data) => {
            try {
                const response = await api.createMfa(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{uuid: string}} data
         * @returns {Promise<*>}
         */
        removeMfa: async ({dispatch}, data) => {
            try {
                const response = await api.removeMfa(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetMfaList: ({commit}) => commit(mutationTypes.RESET_MFA_LIST)
    },
    mutations: {
        [mutationTypes.RESET_MFA_LIST]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_MFA_LIST]: (state, data) => state.mfaList = data
    }
}
